import type { IconName } from '@acme/assets';
import { Icon } from '@acme/assets';
import { Link } from 'react-router-dom';

interface NavigationItem {
  label: string;
  iconName: IconName;
  path: string;
  disabled?: boolean;
}

interface NavigationProps {
  items: NavigationItem[];
  className?: string;
  disabled?: boolean;
  currentPath?: string;
}

export const Navigation = ({
  items,
  className,
  currentPath,
}: NavigationProps) => {
  return (
    <nav
      className={`font-inter flex w-full flex-col   font-medium leading-[normal] ${className}`}
    >
      {items.map((item, index) => {
        const isActive = currentPath === item.path;

        return (
          <Link
            key={index}
            to={item.disabled ? '#' : item.path}
            className={`flex items-center gap-3 px-3 py-3 rounded-lg transition-colors ${
              item.disabled
                ? '!cursor-default opacity-50 text-text-secondary'
                : `cursor-pointer hover:text-brand-primary-default ${
                    isActive
                      ? '  text-brand-primary-default bg-purple-50'
                      : 'text-gray-700 '
                  }`
            }`}
            onClick={(e) => {
              if (item.disabled) {
                e.preventDefault();
              }
            }}
          >
            <Icon
              name={item.iconName}
              size={20}
              className={`h-5 w-5 ${
                item.disabled ? 'text-gray-400' : 'text-current'
              }`}
              alt={item.label}
            />
            <span className="flex-grow text-base">{item.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};
